import { render } from "./ios-browsers.vue?vue&type=template&id=bfbe9198"
import script from "./ios-browsers.vue?vue&type=script&lang=js"
export * from "./ios-browsers.vue?vue&type=script&lang=js"
script.render = render

export default script